import React from 'react'
import { useNavigate } from 'react-router-dom'

function NavbarLink({ href, contenido, setCategoriaDesplegada, categoriaDesplegada,menuAbierto,setCategoriaDesplegadaRes,setMenuAbierto }) {
  const navigate = useNavigate();
  const accionNavLink = () => {
    if (contenido === 'Categoría') {
      setCategoriaDesplegada(!categoriaDesplegada)
      setMenuAbierto && setCategoriaDesplegadaRes(true)
    }
    else {
      menuAbierto && setMenuAbierto(false)
      !menuAbierto && setCategoriaDesplegada(false)
      let ruta = contenido.toLowerCase().replace(" ", "");
      navigate(`/${ruta}`)
    }
  }
  return (
    menuAbierto ?
    <button onClick={accionNavLink} href={`${href}`} className={`font-bold w-full text-start my-3 p-2 border-b-2 border-b-Verde `}>{contenido }</button>
  :
    <button onClick={accionNavLink} href={`${href}`} className={`font-bold ${categoriaDesplegada && 'text-Rojo'} hover:text-Rojo`}>{contenido }</button>
  )
}

export default NavbarLink